import { supabase } from '../../supabase';

/**
 * RD-SEC-051 (from RD-SESS-034) — is this session's assurance level FINAL?
 * NOT settled while a 2FA-enrolled user is still at aal1 (`currentLevel !== 'aal2'`
 * && `nextLevel === 'aal2'`): every MFA-gated read returns ZERO rows with no
 * error then, and any write is premature. Local JWT decode, no network.
 * Fails to "settled" (a client without the MFA API behaves as before).
 * @returns {Promise<{ settled: boolean, aal: string|null }>}
 */
export async function readAssurance(client = supabase) {
  try {
    const { data } = await client.auth.mfa.getAuthenticatorAssuranceLevel();
    if (!data) return { settled: true, aal: null };
    return {
      settled: !(data.currentLevel !== 'aal2' && data.nextLevel === 'aal2'),
      aal: data.currentLevel ?? null,
    };
  } catch {
    return { settled: true, aal: null };
  }
}

export async function isAssuranceSettled(client = supabase) {
  return (await readAssurance(client)).settled;
}

export default isAssuranceSettled;
